import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatchCart, useCart } from './ContextReducer';

export default function Card(props) {
  let data = useCart();

  let navigate = useNavigate();
  const [qty, setQty] = useState(1);
  const [size, setSize] = useState('');
  const priceRef = useRef();

  let options = props.options;
  let priceOptions = Object.keys(options);
  let foodItem = props.item;
  const dispatch = useDispatchCart();
  const handleClick = () => {
    if (!localStorage.getItem('token')) {
      navigate('/login');
    }
  };
  const handleQty = (newQty) => {
    setQty(newQty);
  };
  const handleOptions = (e) => {
    setSize(e.target.value);
  };
  const handleAddToCart = async () => {
    let food = [];
    for (const item of data) {
      if (item.id === foodItem._id) {
        food = item;
        break;
      }
    }
    if (food !== []) {
      if (food.size === size) {
        await dispatch({ type: 'UPDATE', id: foodItem._id, price: finalPrice, qty: qty });
        return;
      } else if (food.size !== size) {
        await dispatch({ type: 'ADD', id: foodItem._id, name: foodItem.name, price: finalPrice, qty: qty, size: size, img: props.ImgSrc });
       
        return;
      }
      return;
    }

    await dispatch({ type: 'ADD', id: foodItem._id, name: foodItem.name, price: finalPrice, qty: qty, size: size });
  };

  useEffect(() => {
    setSize(priceRef.current.value);
  }, []);

  let finalPrice = qty * parseInt(options[size]);

  return (
    <div className="card mx-auto text-center">
      <img src={props.ImgSrc} className="card-img-top" alt="Card Image" />
      <div className="card-body">
        <h5 className="card-title">{props.foodName}</h5>
        <div className="card-price">₹{finalPrice}/-</div>
        <div className="card-details">
        
        <div className="card-select">
  <label className="card-details-text" htmlFor="quantity">Quantity</label>
  <div className="quantity-control">
    <button className="quantity-btn" onClick={() => handleQty(qty - 1)} disabled={qty === 1}>-</button>
    <span className="quantity-value">{qty}</span>
    <button className="quantity-btn" onClick={() => handleQty(qty + 1)}>+</button>
  </div>
</div>



        <div className="card-select">
          <label className="card-details-text" htmlFor="price">Size</label>
          <select id="price" className="select-box" ref={priceRef} onChange={handleOptions}>
            {priceOptions.map((i) => (
              <option key={i} value={i}>{i}</option>
            ))}
          </select>
        </div>
      </div>
      <button className="btn btn-success add-to-cart-btn" onClick={handleAddToCart}>Add to Cart</button>
    </div>
  </div>
  
  )
}